import { HttpClient } from "@angular/common/http";
import { map, catchError } from "rxjs";
import { httpOptionsDefault } from "../../_shared/constants";
import { PaymentResult } from "../../_shared/models/PaymentResult";
import { WebApiService } from "../WebApiService";



export class BoletoItauController {



  constructor(public _http: HttpClient, public _webApi: WebApiService) {
  }
  pay(schemeId: number, orderId: number, paymentId: number): Promise<PaymentResult> {



    return this._http.get(this._webApi.GetApiAddress() + `/boletoitau/payScheme/${schemeId}/${orderId}/${paymentId}`, httpOptionsDefault)
      .pipe(
        map(result => {


          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: PaymentResult) => {


        return result;
      });

  }

  getLast(orderId: any): Promise<PaymentResult> {

    return this._http.get(this._webApi.GetApiAddress() + `/boletoitau/getLast/${orderId}`, httpOptionsDefault)
      .pipe(
        map(result => {


          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: PaymentResult) => {


        return result;
      });
  }
}
